const collator = new Intl.Collator('en', { numeric: true, sensitivity: 'base' });

function sortValue(item, key) {
    if (key === 'application') return item.name;
    if (key === 'cluster') return item.cluster;
    if (key === 'type') return item.type && item.type.name;
    const param = item[key];
    if (!param) return null;
    if (Number.isFinite(param.sort_value)) return param.sort_value;
    return param.value || null;
}

export function sortApplications(items, sortBy = [], sortDesc = []) {
    const key = sortBy[0] || 'application';
    const direction = sortDesc[0] ? -1 : 1;
    return items.slice().sort((a, b) => {
        const av = sortValue(a, key);
        const bv = sortValue(b, key);
        // Missing telemetry stays at the bottom in either direction.
        if (av == null && bv != null) return 1;
        if (bv == null && av != null) return -1;
        let compared = 0;
        if (av != null && bv != null) {
            compared = typeof av === 'number' && typeof bv === 'number' ? av - bv : collator.compare(String(av), String(bv));
        }
        return compared * direction || collator.compare(a.name, b.name) || collator.compare(a.id, b.id);
    });
}

export function sortApplicationGroups(groups, order) {
    if (order !== 'name-asc' && order !== 'name-desc') return groups;
    return groups.slice().sort((a, b) => {
        // Keep the unmatched bucket last regardless of the chosen group order.
        if (a.id === 'other') return 1;
        if (b.id === 'other') return -1;
        return (collator.compare(a.name, b.name) || collator.compare(a.id, b.id)) * (order === 'name-desc' ? -1 : 1);
    });
}
